{
  "/assets/picaroo/10_descopera_800x800.webp": {
    "width": 800,
    "height": 800,
    "src": "/assets/responsive/aebb93f36834-800.webp",
    "srcset": "/assets/responsive/aebb93f36834-400.webp 400w, /assets/responsive/aebb93f36834-800.webp 800w"
  },
  "/assets/picaroo/1_2400x1714.webp": {
    "width": 2400,
    "height": 1714,
    "src": "/assets/responsive/f7d9653a92af-800.webp",
    "srcset": "/assets/responsive/f7d9653a92af-400.webp 400w, /assets/responsive/f7d9653a92af-800.webp 800w, /assets/responsive/f7d9653a92af-1440.webp 1440w"
  },
  "/assets/picaroo/1_descopera_800x800.webp": {
    "width": 800,
    "height": 800,
    "src": "/assets/responsive/015448f41770-800.webp",
    "srcset": "/assets/responsive/015448f41770-400.webp 400w, /assets/responsive/015448f41770-800.webp 800w"
  },
  "/assets/picaroo/2_1200x1800.webp": {
    "width": 1200,
    "height": 1800,
    "src": "/assets/responsive/ac622cdf1ff0-800.webp",
    "srcset": "/assets/responsive/ac622cdf1ff0-400.webp 400w, /assets/responsive/ac622cdf1ff0-800.webp 800w, /assets/responsive/ac622cdf1ff0-1200.webp 1200w"
  },
  "/assets/picaroo/2_descopera_533x800.webp": {
    "width": 533,
    "height": 800,
    "src": "/assets/responsive/f045d22a5e5f-533.webp",
    "srcset": "/assets/responsive/f045d22a5e5f-400.webp 400w, /assets/responsive/f045d22a5e5f-533.webp 533w"
  },
  "/assets/picaroo/3_900x1350.webp": {
    "width": 900,
    "height": 1350,
    "src": "/assets/responsive/4982d5418598-800.webp",
    "srcset": "/assets/responsive/4982d5418598-400.webp 400w, /assets/responsive/4982d5418598-800.webp 800w, /assets/responsive/4982d5418598-900.webp 900w"
  },
  "/assets/picaroo/3_descopera_800x800.webp": {
    "width": 800,
    "height": 800,
    "src": "/assets/responsive/22330aba833a-800.webp",
    "srcset": "/assets/responsive/22330aba833a-400.webp 400w, /assets/responsive/22330aba833a-800.webp 800w"
  },
  "/assets/picaroo/4_900x1350.webp": {
    "width": 900,
    "height": 1350,
    "src": "/assets/responsive/b4b5c36572af-800.webp",
    "srcset": "/assets/responsive/b4b5c36572af-400.webp 400w, /assets/responsive/b4b5c36572af-800.webp 800w, /assets/responsive/b4b5c36572af-900.webp 900w"
  },
  "/assets/picaroo/4_descopera_800x800.webp": {
    "width": 800,
    "height": 800,
    "src": "/assets/responsive/62bf6566c796-800.webp",
    "srcset": "/assets/responsive/62bf6566c796-400.webp 400w, /assets/responsive/62bf6566c796-800.webp 800w"
  },
  "/assets/picaroo/5_descopera_800x800.webp": {
    "width": 800,
    "height": 800,
    "src": "/assets/responsive/51908c875096-800.webp",
    "srcset": "/assets/responsive/51908c875096-400.webp 400w, /assets/responsive/51908c875096-800.webp 800w"
  },
  "/assets/picaroo/7_descopera_800x800.webp": {
    "width": 800,
    "height": 800,
    "src": "/assets/responsive/2a20f83aaea6-800.webp",
    "srcset": "/assets/responsive/2a20f83aaea6-400.webp 400w, /assets/responsive/2a20f83aaea6-800.webp 800w"
  },
  "/assets/picaroo/8_descopera_800x800.webp": {
    "width": 800,
    "height": 800,
    "src": "/assets/responsive/18e1f0345238-800.webp",
    "srcset": "/assets/responsive/18e1f0345238-400.webp 400w, /assets/responsive/18e1f0345238-800.webp 800w"
  },
  "/assets/picaroo/9_descopera_800x800.webp": {
    "width": 800,
    "height": 800,
    "src": "/assets/responsive/41f478c1ec39-800.webp",
    "srcset": "/assets/responsive/41f478c1ec39-400.webp 400w, /assets/responsive/41f478c1ec39-800.webp 800w"
  },
  "/assets/picaroo/baia_800x800.webp": {
    "width": 800,
    "height": 800,
    "src": "/assets/responsive/cb49f36a321b-800.webp",
    "srcset": "/assets/responsive/cb49f36a321b-400.webp 400w, /assets/responsive/cb49f36a321b-800.webp 800w"
  },
  "/assets/picaroo/bega_1200x1600.webp": {
    "width": 1200,
    "height": 1600,
    "src": "/assets/responsive/f69eb29b28e4-800.webp",
    "srcset": "/assets/responsive/f69eb29b28e4-400.webp 400w, /assets/responsive/f69eb29b28e4-800.webp 800w, /assets/responsive/f69eb29b28e4-1200.webp 1200w"
  },
  "/assets/picaroo/bucatarie_800x800.webp": {
    "width": 800,
    "height": 800,
    "src": "/assets/responsive/6e354e2ec12e-800.webp",
    "srcset": "/assets/responsive/6e354e2ec12e-400.webp 400w, /assets/responsive/6e354e2ec12e-800.webp 800w"
  },
  "/assets/picaroo/camera-de-zi_800x800.webp": {
    "width": 800,
    "height": 800,
    "src": "/assets/responsive/10df7a8c860f-800.webp",
    "srcset": "/assets/responsive/10df7a8c860f-400.webp 400w, /assets/responsive/10df7a8c860f-800.webp 800w"
  },
  "/assets/picaroo/contact_1067x1600.webp": {
    "width": 1067,
    "height": 1600,
    "src": "/assets/responsive/d5e5b1ac9744-800.webp",
    "srcset": "/assets/responsive/d5e5b1ac9744-400.webp 400w, /assets/responsive/d5e5b1ac9744-800.webp 800w, /assets/responsive/d5e5b1ac9744-1067.webp 1067w"
  },
  "/assets/picaroo/curte_800x800.webp": {
    "width": 800,
    "height": 800,
    "src": "/assets/responsive/597a65414649-800.webp",
    "srcset": "/assets/responsive/597a65414649-400.webp 400w, /assets/responsive/597a65414649-800.webp 800w"
  },
  "/assets/picaroo/dormitor_800x800.webp": {
    "width": 800,
    "height": 800,
    "src": "/assets/responsive/ec59761f0e97-800.webp",
    "srcset": "/assets/responsive/ec59761f0e97-400.webp 400w, /assets/responsive/ec59761f0e97-800.webp 800w"
  },
  "/assets/picaroo/terasa_800x800.webp": {
    "width": 800,
    "height": 800,
    "src": "/assets/responsive/53f39a2497d6-800.webp",
    "srcset": "/assets/responsive/53f39a2497d6-400.webp 400w, /assets/responsive/53f39a2497d6-800.webp 800w"
  }
}
